import { authenticatedApi } from "../../Api/api";
import env from "../../config/env";
import { IDocument } from "../../models/document";


export async function getDocumentDownloadUrl(document: IDocument) {
  const downloadTokenResponse = await authenticatedApi.get("/documents/" + document.id + "/get-download-token");
  const downloadToken = downloadTokenResponse.data?.documentToken;

  if (!downloadToken) return;
  return env.PUBLIC_API_URL + "/documents/" + document.id + "/download?downloadType=view&documentDownloadToken=" + downloadToken;
}

export async function getDocumentBase64Url(document: IDocument) {
  const downloadTokenResponse = await authenticatedApi.get("/documents/" + document.id + "/get-download-token");
  const downloadToken = downloadTokenResponse.data?.documentToken;
  return env.PUBLIC_API_URL + "/documents/" + document.id + "/base64?documentDownloadToken=" + downloadToken;
}

export default async function openDocumentInBrowser(document: IDocument) {

  const downloadTokenResponse = await authenticatedApi.get("/documents/" + document.id + "/get-download-token");
  const downloadToken = downloadTokenResponse.data?.documentToken;

  if (!downloadToken) return;
  window.open(env.PUBLIC_API_URL + "/documents/" + document.id + "/download?downloadType=view&documentDownloadToken=" + downloadToken, '_blank');
}